import * as React from "react";
import { useState } from "react";

import { cn } from "../../utils/cn";

export interface TestProps extends React.HTMLProps<HTMLHeadingElement> {}

const Test = ({ ...props }): TestProps => {
  const [color, setColor] = useState("red");
  return (
    <>
      <h1 className={cn("text-base md:text-md")} {...props}>
        My favorite color is {color}!
      </h1>
      <button type="button" onClick={() => setColor("blue")}>
        Blue
      </button>
    </>
  );
};

Test.displayName = "Test";

export { Test };
